<app-modal [header]="title | translate">
  <ng-container modal-body>

    <p>{{ message | translate }}</p>
    @let historyValue = history();
    @if (historyValue) {
      <app-project-version-history-table
        [project]="project"
        [preselectVersion]="project.currentVersion"
        [projectHistory]="history()"
        [(selectedEntry)]="selectedEntry"
      />
    }
  </ng-container>

  <ng-container modal-footer>
    <button class="btn btn-secondary btn-forward" (click)="cancel()">{{ 'global.label.cancel' | translate }}</button>
    <button class="btn btn-primary btn-forward" id="step_forward" (click)="submitSelectedVersion()">{{ submitButtonText | translate }}</button>
  </ng-container>
</app-modal>
